import { Controller, useFormContext } from 'react-hook-form';

import useTranslation from '@/utils/hooks/translation/useTranslation';

//type
import type { PlatformFormType } from '@/components/pages/settings/platform/types';

//libs
import { validate_auto_publishing_mobile_app } from '@/lib/settings/optionsConfiguration/platformSettings/platform-settings';

//components
import { SelectComponent } from '@/components/base/Select/SelectComponent/SelectComponent';

export function PlatformValidateAutoPublishing() {
    const { t } = useTranslation('settings');

    const options = validate_auto_publishing_mobile_app(t);

    const {
        control,
        formState: { errors }
    } = useFormContext<PlatformFormType>();

    return (
        <Controller
            key={'validate_auto_publishing_mobile_app'}
            control={control}
            name={'validate_auto_publishing_mobile_app'}
            render={({ field: { onChange, value } }) => {
                return (
                    <SelectComponent
                        selected={options?.find((item) => value['value'] === item.value)}
                        setSelected={onChange}
                        label={t('platform_page.validate_auto_publishing_mobile_app')}
                        error={errors.validate_auto_publishing_mobile_app?.message}
                        options={options}
                    />
                );
            }}
        />
    );
}
